import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Modal, Card, CardContent } from '@material-ui/core';
import Header from './header'
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
    root: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '1200 !important',
        padding: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            padding: 0,
        }
    },
    backdrop: {
        backgroundColor: `${theme.palette.app.primary} !important`,
        opacity: 0.8
    },
    inner: {
        width: '100%',
        maxWidth: '900px',
        maxHeight: '90vh',
        margin: 'auto',
        overflow: 'auto',
        backgroundColor: '#F2F5FB',
        '&:focus': {
            outline: 'none !important'
        },
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        position: 'relative',
        borderRadius: theme.spacing(1),
        [theme.breakpoints.down('xs')]: {
            maxHeight: '100vh',
            borderRadius: 0,
            // add small horizontal margins on very small screens so dialog isn't flush to edges
            marginLeft: 10,
            marginRight: 10,
        }
    },
    content: {
        flex: 1,
        //marginTop: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column'
    },
    CardContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '100%',
        padding: theme.spacing(3),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        }
    },
    footer: {
        padding: theme.spacing(3),
        maxHeight: 80
    }
}));

const ModalWrap = ({ open, title, closeModal, backdropStyle, footer, rightComponent, headerDarkmode, children }) => {
    const classes = useStyles();
    return (
        <Modal
            className={classes.root}
            open={open}
            onClose={() => closeModal()}
            aria-labelledby="users-modal-title"
            aria-describedby="users-modal-description"
            //disableBackdropClick
            BackdropProps={backdropStyle || { className: classes.backdrop }}
        >
            <Card className={classes.inner}>
                <Header
                    headerDarkmode={headerDarkmode}
                    title={title}
                    rightComponent={rightComponent}
                    closeModal={() => closeModal()}
                />
                <CardContent className={classes.CardContent}
                    style={{ minHeight: footer ? 'calc(100% - 152px)' : 'auto' }}>
                    <div className={classes.content}>
                        {children}
                    </div>
                </CardContent>
                {
                    footer &&
                    <footer className={classes.footer}>
                        {footer}
                    </footer >
                }
            </Card>
        </Modal >
    );
};
ModalWrap.propTypes = {
    open: PropTypes.bool,
    title: PropTypes.string,
    closeModal: PropTypes.func,
    backdropStyle: PropTypes.any,
    footer: PropTypes.any,
    rightComponent: PropTypes.any,
    headerDarkmode: PropTypes.bool,
    children: PropTypes.any
};

export default ModalWrap;
